import { useTranslation } from 'react-i18next';
import { ArrowRight } from 'lucide-react';
import { FullPageCta } from '@/shared/components/FullPageCta';

interface WelcomeScreenProps {
  onContinue: () => void;
}

export function WelcomeScreen({ onContinue }: WelcomeScreenProps) {
  const { t } = useTranslation('onboarding');
  return (
    <div className="stagger-children relative flex min-h-[72vh] flex-col items-center justify-center text-center">
      <span className="text-[11px] font-medium uppercase tracking-[0.32em] text-muted-foreground">
        {t('insights.welcome.eyebrow')}
      </span>

      <h1 className="mt-7 text-balance text-5xl font-bold leading-[1.02] tracking-tight text-foreground sm:text-7xl">
        {t('insights.welcome.title')}
      </h1>

      <div className="mt-9 flex flex-col items-center gap-7">
        <div aria-hidden className="h-px w-12 bg-foreground/20" />
        <p className="max-w-md text-balance text-lg text-muted-foreground">
          {t('insights.welcome.subtitle')}
        </p>
      </div>

      <FullPageCta onClick={onContinue} className="mt-10">
        {t('insights.welcome.cta')}
        <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1 rtl:rotate-180 rtl:group-hover:-translate-x-1" />
      </FullPageCta>

      <div
        aria-hidden
        className="mt-16 flex w-full max-w-xl items-center gap-3"
      >
        <span className="h-px flex-1 bg-border" />
        <span className="flex items-center gap-1.5">
          <span className="h-1 w-1 rounded-full bg-border" />
          <span className="h-1 w-1 rounded-full bg-border" />
          <span className="h-1 w-1 rounded-full bg-border" />
        </span>
        <span className="h-px flex-1 bg-border" />
      </div>
    </div>
  );
}
